import { IRuleGroupService } from "../../service/evaluation/RuleGroupService";

export default class GetRuleGroupElementsInteractor {
  private ruleGroupService: IRuleGroupService;

  constructor(ruleGroupService) {
    this.ruleGroupService = ruleGroupService;
  }

  async execute(ruleGroupId: number) {
    return this.ruleGroupService.getRuleGroupElements(ruleGroupId);
  }
}
